<template>
    <div class="transfer-ownership">
        <h5 class="mb-4"> {{ list.length }} Requests(s)</h5>
        <b-overlay :show="apiLoading" rounded="sm" spinner-variant="primary">
            <div class="list">
                <Card v-for="(item, index) in list" :key="index" :data="item"/>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import ApiMixin from "@core/mixin/ApiMixin";
import Card from "./Card";

export default {
    name: "Index",
    components: {Card},
    mixins: [ApiMixin],
    data() {
        return {
            list: [],
            apiLoading: false
        }
    },
    methods: {
        getMyTransfers() {
            this.apiLoading = true
            $.ajax({
                url: '/transfer_ownership/my_transfers?per_page=200',
                method: 'GET'
            })
                .then(res => {
                    this.list = res.data.data
                })
                .catch(xhr => {
                  this.$errorNotify(xhr.responseJSON.message )
                })
                .always(() => {
                    this.apiLoading = false;
                });
        }
    },
    mounted() {
        this.getMyTransfers()
    }
}
</script>

<style lang="scss" scoped>
.transfer-ownership {
    padding: 30px;
    padding-top: 0;

    .list {
        display: flex;
        gap: 10px;
        flex-direction: column;

    }
}
</style>
